import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { AuthScreenLayout } from "@/features/auth/components/auth-screen-layout";

export function ForgotPasswordPage() {
	return (
		<AuthScreenLayout>
			<div className="forgot-password-page">
				<div className="forgot-password-page__heading">
					<h1 className="page-title">Recuperar senha</h1>
					<p className="forgot-password-page__description">
						A recuperação de senha estará disponível em breve. Enquanto isso,
						entre em contato com o suporte se precisar acessar sua conta.
					</p>
				</div>
				<Button
					asChild
					variant="outline"
					className="forgot-password-page__action"
				>
					<Link to="/login">
						<ArrowLeft />
						Voltar para o login
					</Link>
				</Button>
			</div>
		</AuthScreenLayout>
	);
}
